import { createFileRoute } from "@tanstack/react-router";

import { BEST_SERVERS_FAQS } from "@/components/Mcp/mcpArticleFaqs";
import { MCP_ARTICLES } from "@/components/Mcp/mcpArticles";
import { McpBestServersPage } from "@/components/Mcp/McpBestServersPage";
import { mcpArticleHead } from "@/components/Mcp/mcpHead";

const article = MCP_ARTICLES.find(
  (a) => a.slug === "best-mcp-servers-for-designers",
)!;

export const Route = createFileRoute("/mcp/best-mcp-servers-for-designers")({
  component: McpBestServersPage,
  head: () =>
    mcpArticleHead({
      title: article.metaTitle,
      description: article.metaDescription,
      path: "/mcp/best-mcp-servers-for-designers",
      breadcrumbName: article.name,
      faqs: BEST_SERVERS_FAQS,
    }),
});
